import React from 'react';
import { Star, Quote } from 'lucide-react';
import Reveal from './Reveal';

const FILES_BASE = process.env.REACT_APP_BACKEND_URL;

export const LandingTestimonials = ({ landing, testimonials }) => {
  const list = (testimonials || []).filter((t) => t.is_active !== false).sort((a, b) => (a.order_index || 0) - (b.order_index || 0));
  if (list.length === 0) return null;

  return (
    <section id="testimonials" className="border-y border-teal-900/20 bg-[#0A192F]/40 py-20 md:py-32" data-testid="landing-testimonials">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <span className="text-sm font-bold uppercase tracking-wider text-teal-400">آراء عملائنا</span>
            <h2 className="font-display mt-3 text-2xl font-bold text-white sm:text-3xl lg:text-4xl" data-testid="landing-testimonials-title">
              {landing?.testimonials_title || 'آراء عملائنا'}
            </h2>
            <p className="mt-3 text-slate-400" data-testid="landing-testimonials-subtitle">
              {landing?.testimonials_subtitle || 'منشآت رياضية تثق بتسيار في إدارة أعمالها'}
            </p>
          </div>
        </Reveal>

        <div className="mt-12 flex flex-wrap justify-center gap-6">
          {list.map((t, i) => {
            const photoUrl = t.photo ? (t.photo.startsWith('http') ? t.photo : `${FILES_BASE}/api/files/${t.photo}`) : null;
            return (
              <Reveal key={t.id || i} delay={i * 80} className="w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]">
                <div className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.02] p-6" data-testid={`landing-testimonial-${i}`}>
                  <Quote className="h-6 w-6 text-teal-500/40" />
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-300">{t.quote}</p>
                  <div className="mt-4 flex items-center gap-0.5">
                    {Array.from({ length: 5 }).map((_, idx) => (
                      <Star key={idx} className={`h-3.5 w-3.5 ${idx < (t.rating || 5) ? 'fill-orange-400 text-orange-400' : 'text-slate-600'}`} />
                    ))}
                  </div>
                  <div className="mt-4 flex items-center gap-3 border-t border-white/5 pt-4">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center overflow-hidden rounded-full border border-teal-900/30 bg-teal-500/10">
                      {photoUrl ? <img src={photoUrl} alt={t.customer_name} className="h-full w-full object-cover" /> : <span className="font-display text-sm font-bold text-teal-400">{(t.customer_name || '؟').charAt(0)}</span>}
                    </div>
                    <div>
                      <div className="font-display text-sm font-bold text-white">{t.customer_name}</div>
                      <div className="text-xs text-slate-500">{[t.job_title, t.org_name].filter(Boolean).join(' — ')}</div>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LandingTestimonials;
